<template>
  
    <VehicleConfigurationNav v-if="!loading" @usage="setUsage" />
  
    <StepsToCalculateNav v-if="!loading" :fuelCost="costElectric" :equipment="costEquipment" :otherCost="costOther" :active="1" :usage="currentUsage" />

    <div class="container-fluid" v-if="!loading">
        <div class="row my-5">
            <div class="col-sm-6 vehicle-card-col">
                <VehicleCard :vehicle="vehicleInfo" />
            </div>
            <div class="col-sm-6 text-left vehicle-input-col">
                <p class="heading-3">Equipment Cost Inputs</p>
                <div class="input-block">

                    <!-- Vehicle Price -->
                    <div class="form-group mt-5">
                        <label for="electricVehiclePrice" class="w-100">Vehicle Price ($) <button class="info-toggle font-bold mt-0" data-toggle="modal" data-target="#info-modal-vehicle-price">?</button></label>
                        <input type="text" class="range-output output-text" v-model="vehiclePriceFormatted" @input="formatInputVehiclePrice(); calculateTotals()" @change="trackVehiclePrice(vehiclePrice)">
                        <input type="number" id="electricVehiclePriceOutput" class="range-output d-none" min="0" max="500000" v-model="vehiclePrice"> 
                        <input class="form-control-range" type="range" id="electricVehiclePrice" name="electricVehiclePrice" min="0" max="500000" v-model="vehiclePrice" @input="calculateTotals(); formatInputFromSliderVehiclePrice()" @change="trackVehiclePrice(vehiclePrice)">
                    </div>
                    
                    <!-- Vehicle Resale -->
                    <div class="form-group mt-5">
                        <label for="electricVehicleResale" class="w-100">Vehicle Resale Value ($)</label>
                        <input type="text" class="range-output output-text" v-model="vehicleResaleFormatted" @input="formatInputVehicleResale(); calculateTotals()" @change="trackResalePrice(vehicleResale)">
                        <input type="number" id="electricVehicleResaleOutput" class="range-output d-none" min="0" max="500000" v-model="vehicleResale">
                        <input class="form-control-range" type="range" id="electricVehicleResale" name="electricVehicleResale" min="0" max="500000" v-model="vehicleResale" @input="calculateTotals(); formatInputFromSliderVehicleResale()" @change="trackResalePrice(vehicleResale)">
                    </div>
                    
                    <!-- Charger Price -->
                    <div class="form-group form-group-inline text-input-group mt-5 mb-0">
                        <label for="electricChargerPrice">Charger Price ($)</label>
                        <input type="text" class="range-output output-text" v-model="chargerPriceFormatted" @input="formatInputChargerPrice(); calculateTotals()" @change="trackChargerPrice(chargerPrice)">
                        <input type="number" id="electricChargerPrice" class="range-output d-none" min="0" max="200000" v-model="chargerPrice" @change="trackChargerPrice(chargerPrice)">
                    </div>
                    
                    <!-- Vehicles per Charger -->
                    <div class="form-group form-group-inline text-input-group mt-0">
                        <label for="vehiclesPerCharger">Vehicles Per Charger</label>
                        <input type="number" id="vehiclesPerCharger" class="range-output" min="1" max="10" v-model="perCharger" @input="calculateTotals()" @change="convertValues(); trackVehiclesPerCharger(perCharger)">
                    </div>
                    
                    <!-- Amortization -->
                    <div class="form-group mt-5">
                        <label for="electricAmortization" class="w-100">Amortization (years)</label>
                        <input type="number" id="electricAmortizationOutput" class="range-output output-text" min="0" max="10" v-model="amortization" @input="calculateTotals()" @change="trackAmortization(amortization)">
                        <input class="form-control-range" type="range" id="electricAmortization" name="electricAmortization" min="0" max="10" v-model="amortization" @input="convertValues(); calculateTotals()" @change="trackAmortization(amortization)">
                    </div>
                    
                    <!-- Rebate Credit -->
                    <div class="form-group my-5">
                        <label for="electricRebate" class="w-100">Rebate/Credit ($)</label>
                        <input type="text" class="range-output output-text" v-model="rebateFormatted" @input="formatInputRebate(); calculateTotals()" @change="trackRebate(rebate)">
                        <input type="number" id="electricRebateOutput" class="range-output d-none" min="0" max="300000" v-model="rebate">
                        <input class="form-control-range" type="range" id="electricRebate" name="electricRebate" min="0" max="300000" v-model="rebate" @input="calculateTotals(); formatInputFromSliderRebate()" @change="trackRebate(rebate)">
                    </div>

                </div>


                <div class="text-center next-link position-relative">
                    <router-link to="/electric/other-costs" class="big-link heading-2 text-center" @click="trackNextCategory()">Next Step <img :src="`${imagePath}/arrow-white.png`" alt=""></router-link>
                </div>
            </div>
        </div>
    </div>

    <div class="container-footer" v-if="!loading">
        <div class="container-fluid">
            <div class="row py-4">
                <div class="col-sm-12">
                    <div class="totals-container d-flex w-100 justify-content-between">
                        <div class="totals-item">
                            <p class="text-uppercase">Equipment Costs Total</p>
                            <div class="d-flex justify-content-between">
                            
                                <div class="mr-5">
                                    <p v-if="currentUsage == 'miles'" class="mb-0" id="costPerMileOuput" v-html="formatPrice((costEquipment['cost-per-mile']) * currencyExchange)"></p>
                                    <p v-if="currentUsage == 'hours'" class="mb-0" id="costPerMileOuput" v-html="formatPrice((costEquipment['cost-per-hour']) * currencyExchange)"></p>
                                    <small>Total Cost Per {{ currentUsage == 'miles' ? 'Mile' : 'Hour' }}</small>
                                </div>
                    
                                <div class="">
                                    <p class="mb-0" id="annualFuelCostOuput" v-html="formatPrice((costEquipment['annual-cost']) * currencyExchange, 0)"></p>
                                    <small>Total Annual Cost</small>
                                </div>
                    
                            </div>
                        </div>
                        
                        <ElectricFooter :fuelCost="costElectric" :equipmentCost="costEquipment" :otherCost="costOther" :usage="currentUsage" />

                        <ElectricSummaryModal :vehicle="vehicleInfo" :fuelCost="costElectric" :equipment="costEquipment" :otherCost="costOther" :usage="currentUsage" />

                        <div id="info-modal-vehicle-price" class="modal-summary modal-info modal fade" tabindex="-1">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header py-2">
                                        <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                                        <span class="material-icons" aria-hidden="true">clear</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="mb-0">
                                            Please visit your local Peterbilt dealership to learn more about electric vehicle prices. An initial electric vehicle price estimate of three times a comparable diesel vehicle may be appropriate.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import StepsToCalculateNav from "../components/StepsToCalculateNav.vue"
    import VehicleConfigurationNav from "@/components/VehicleConfigurationNav.vue"

    import VehicleCard from "../components/VehicleCard"
    import ElectricFooter from "../components/ElectricFooter"
    import ElectricSummaryModal from "../components/ElectricSummaryModal"

    export default {
        name: 'ElectricEquipmentCosts',
        components: {
            VehicleCard,
            ElectricFooter,
            StepsToCalculateNav,
            VehicleConfigurationNav,
            ElectricSummaryModal
        },
        data() {
            return {
                currentUsage: 'miles', // set as default
                costElectric: {},
                costEquipment: {},
                costOther: {},
                vehiclePrice: 0,
                vehiclePriceFormatted: 0,
                vehicleResale: 0,
                vehicleResaleFormatted: 0,
                chargerPrice: 0,
                chargerPriceFormatted: 0,
                perCharger: 1,
                amortization: 0,
                rebate: 0,
                rebateFormatted: 0,
                annualRebate: 0,
                fuelCost: 0,
                currencyType: '',
                currencyExchange: 0,
                currencyConversion: 1,
                loading: true,
                imagePath: process.env.VUE_APP_ASSET_LOCATION
            }
        },
        mounted() {

            // Set currency
            this.currencyType = sessionStorage.getItem('currency')
            this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1
            this.currencyConversion = Number(localStorage.getItem('USDtoCAD'))

            // Grab vehicle info from storage and begin filling in props
            // vehicleInfoHidden is for setting equivalent values for diesel and electric
            this.vehicleInfo = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
            this.vehicleInfoHidden = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))


            this.costElectric = JSON.parse(sessionStorage.getItem('electricFuelCost'))
            this.costEquipment = JSON.parse(sessionStorage.getItem('electricEquipmentCost'))
            this.costOther = JSON.parse(sessionStorage.getItem('electricOtherCost'))

            // If US from CA
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'true') {
                this.vehiclePrice = Math.round(this.vehicleInfo.equipment.tractorPrice / this.currencyConversion)
                this.vehicleResale = Math.round(this.vehicleInfo.equipment.resaleValue / this.currencyConversion)
                this.chargerPrice = Math.round(this.vehicleInfo.equipment.chargerPrice / this.currencyConversion)
                this.rebate = Math.round(this.costEquipment['rebate'] / this.currencyConversion)
            }

            // If CA from US
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'false') {
                this.vehiclePrice = Math.round(this.vehicleInfo.equipment.tractorPrice * this.currencyConversion)
                this.vehicleResale = Math.round(this.vehicleInfo.equipment.resaleValue * this.currencyConversion)
                this.chargerPrice = Math.round(this.vehicleInfo.equipment.chargerPrice * this.currencyConversion)
                this.rebate = Math.round(this.costEquipment['rebate'] * this.currencyConversion)
            }

            if (sessionStorage.getItem('fromCanada') == null) {
                this.vehiclePrice = this.vehicleInfo.equipment.tractorPrice
                this.vehicleResale = this.vehicleInfo.equipment.resaleValue
                this.chargerPrice = this.vehicleInfo.equipment.chargerPrice
                this.rebate = this.costEquipment['rebate']
            }

            this.amortization = this.vehicleInfo.equipment.amortization
            this.perCharger = this.costEquipment['per-charger']
            this.vehiclePriceFormatted = (this.vehiclePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.vehicleResaleFormatted = (this.vehicleResale).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.chargerPriceFormatted = (this.chargerPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.rebateFormatted = (this.rebate).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            
            this.currentCurrency = sessionStorage.getItem('currency')
            this.usToCa = 1.27
            this.gallonToLitre = 3.79
            this.milesToKm = 1.61

            this.convertValues()
            this.calculateTotals()

            this.loading = false

            // Tracking
            window.gtag('event', 'page_view', {
                page_title: 'Cost Calculator - Electric Equipment Cost',
                page_location: '/electric/equipment-costs'
            })


        },

        watch: {
            vehiclePriceFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.vehiclePriceFormatted = result)
            },
            vehicleResaleFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.vehicleResaleFormatted = result)
            },
            chargerPriceFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.chargerPriceFormatted = result)
            },
            rebateFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => this.rebateFormatted = result)
            }
        },

        methods: {

            convertValues() {
                this.perCharger = Number(this.perCharger).toFixed(1)
                this.amortization = Number(this.amortization).toFixed(1)
            },

            calculateTotals() {
                // This Block of variables allows values to persist after going back
                // or after changing from Diesel Electric & vice-versa
                this.vehicleInfo.equipment.tractorPrice = this.vehiclePrice
                this.vehicleInfo.equipment.resaleValue = this.vehicleResale
                this.vehicleInfo.equipment.chargerPrice = this.chargerPrice
                this.vehicleInfo.equipment.amortization = this.amortization
                this.vehicleInfoHidden.equipment.amortization = this.amortization

                localStorage.setItem('calculatorVehicleElectric', JSON.stringify(this.vehicleInfo))
                localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(this.vehicleInfoHidden))

                let totalEquipmentCosts =  parseFloat(((this.vehiclePrice - this.vehicleResale) + (this.chargerPrice / this.perCharger) - this.rebate)  / this.amortization) 
                let costPerMileOutput = Number(this.vehicleInfo.fuel.mileage) > 0 ? parseFloat(totalEquipmentCosts / this.vehicleInfo.fuel.mileage).toFixed(2) : 0
                let costPerHourOutput = Number(this.vehicleInfo.fuel.hours) > 0 ? parseFloat(totalEquipmentCosts / this.vehicleInfo.fuel.hours).toFixed(2) : 0

                // Set footer totals
                this.totalAnnualCost = totalEquipmentCosts
                this.totalCostPerMile = costPerMileOutput
                this.totalCostPerHour = costPerHourOutput

                // Kick final calculations to storage so we can keep the value for use on later tabs.
                //TODO  In the future, we should leverage VueX for any sort of data management. Great in-app storage.
                sessionStorage.setItem('electricEquipmentCost', JSON.stringify({
                    'annual-cost': Number(totalEquipmentCosts), 
                    'cost-per-mile': Number(costPerMileOutput),
                    'cost-per-hour': Number(costPerHourOutput),
                    'vehicle-price': Number(this.vehicleInfo['equipment']['tractorPrice']),                    
                    'resale': Number(this.vehicleInfo.equipment.resaleValue),
                    'charger-price': Number(this.vehicleInfo.equipment.chargerPrice),
                    'per-charger': Number(this.perCharger),
                    'rebate': Number(this.rebate),
                    'amortization': Number(this.vehicleInfo.equipment.amortization)
                }))

                this.costEquipment = JSON.parse(sessionStorage.getItem('electricEquipmentCost'))

            },
            
            // Sets Miles or Hours calculations based on selection in navigation
            setUsage(value) {
                (sessionStorage.getItem('usage') == null || sessionStorage.getItem('usage').length === 0) ? this.currentUsage = this.currentUsage : this.currentUsage = value
                this.calculateTotals()
            },

            formatInputVehiclePrice() {
                this.vehiclePriceFormatted = this.vehiclePriceFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.vehiclePrice = Number(this.vehiclePriceFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderVehiclePrice() {
                this.vehiclePriceFormatted = Number(this.vehiclePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            
            formatInputVehicleResale() {
                this.vehicleResaleFormatted = this.vehicleResaleFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.vehicleResale = Number(this.vehicleResaleFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderVehicleResale() {
                this.vehicleResaleFormatted = Number(this.vehicleResale).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            
            formatInputChargerPrice() {
                this.chargerPriceFormatted = this.chargerPriceFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.chargerPrice = Number(this.chargerPriceFormatted.replace(/,/g, ''))
            },

            formatInputRebate() {
                this.rebateFormatted = this.rebateFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.rebate = Number(this.rebateFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderRebate() {
                this.rebateFormatted = Number(this.rebate).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

            formatPrice(value, spaces = 2) {
                let val = (value/1).toFixed(spaces)
                return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            trackNextCategory() {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Next Category',
                    'event_label': this.$route.path
                })
            },
            trackVehiclePrice(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Equipment Cost',
                    'event_label': 'Vehicle Price ' + value
                })
            },
            trackResalePrice(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Equipment Cost',
                    'event_label': 'Resale Price ' + value
                })
            },
            trackChargerPrice(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Equipment Cost',
                    'event_label': 'Charger Price ' + value
                })
            },
            trackVehiclesPerCharger(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Equipment Cost',
                    'event_label': 'Vehicles Per Charger ' + value
                })
            },
            trackAmortization(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Equipment Cost',
                    'event_label': 'Amortization ' + value
                })
            },
            trackRebate(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Equipment Cost',
                    'event_label': 'Rebate ' + value
                })
            }
        }
    }
    
</script>